import { render, staticRenderFns } from "./enBatchSection.vue?vue&type=template&id=befcc5e6&scoped=true"
import script from "./enBatchSection.vue?vue&type=script&lang=js"
export * from "./enBatchSection.vue?vue&type=script&lang=js"
import style0 from "./enBatchSection.vue?vue&type=style&index=0&id=befcc5e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcc5e6",
  null
  
)

export default component.exports